import { useEffect, useRef } from "react"

import { usePageviewTracking } from "../screens/Detail/use-pageview-tracking"

export const useRootPageTracking = (
  visible = false,
  slug: string,
  pageType?: string,
) => {
  const track = usePageviewTracking(false) // track every time the tab becomes visible
  // track pageview exactly once every time the tab switches
  // NOTE: We are aware that the hook also has a "trackOnce" flag,
  // but isn't applicable here
  const trackOnce = useRef(true)
  useEffect(() => {
    if (!visible) {
      trackOnce.current = true
    } else if (trackOnce.current) {
      trackOnce.current = false
      track(slug, (pageType || slug).toLowerCase())
    }
  }, [track, visible, slug])
}
